/*
   Этот файл сгенерирован автоматически при помощи dotnet typegen.
   Не менять руками! Настройки генерации указаны в tgconfig.json.
   Документация доступна по ссылке: https://typegen.readthedocs.io
 */
export class ClientError {
  public message: string = null;
  public stacktrace: string[];
  public location: string = null;
}
